import axios from 'axios';
import { getApiEndpoint } from './utilities';

export default {
    get(id, cb) {
        axios.get(getApiEndpoint() + 'api/session/' + id)
            .then(response => {
                cb(response.data);
            });
    },
    beginStay(cb) {
        axios.post(getApiEndpoint() + 'api/session/begin/stay')
            .then(response => {
                cb(response.data);
            });
    },
    beginGolf(cb) {
        axios.post(getApiEndpoint() + 'api/session/begin/golf')
            .then(response => {
                cb(response.data);
            });
    },
    beginSpa(cb) {
        axios.post(getApiEndpoint() + 'api/session/begin/spa',)
            .then(response => {
                cb(response.data);
            });
    },
    end(id, cb) {
        axios.post(getApiEndpoint() + 'api/session/' + id + '/end',)
            .then(response => {
                cb(response.data);
            });
    },

}